// Formatting helpers (dates, numbers, currency).
export function fmtDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString(undefined, {
    year: "numeric", month: "short", day: "2-digit",
    hour: "2-digit", minute: "2-digit",
  });
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "2-digit" });
}

export function fmtRelative(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return `${Math.floor(diff)}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}

export function fmtNum(n) {
  if (n === null || n === undefined) return "—";
  return new Intl.NumberFormat().format(n);
}

export function fmtCurrency(n, compact = false) {
  if (n === null || n === undefined) return "—";
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: "USD",
    notation: compact ? "compact" : "standard",
    maximumFractionDigits: compact ? 2 : 0,
  }).format(n);
}

export function fmtCost(n) {
  // Fine-grained USD for LLM costs (e.g. $0.0031).
  if (n === null || n === undefined) return "—";
  if (n === 0) return "$0";
  if (n < 0.01)  return `$${n.toFixed(4)}`;
  if (n < 1)     return `$${n.toFixed(3)}`;
  if (n < 100)   return `$${n.toFixed(2)}`;
  return new Intl.NumberFormat(undefined, {
    style: "currency", currency: "USD", maximumFractionDigits: 0,
  }).format(n);
}

export function fmtBytes(b) {
  if (b === null || b === undefined) return "—";
  const units = ["B", "KB", "MB", "GB", "TB"];
  let i = 0;
  let v = Number(b);
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v.toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

export function fmtSeconds(s) {
  if (s === null || s === undefined) return "—";
  if (s < 1) return `${Math.round(s * 1000)} ms`;
  if (s < 60) return `${s.toFixed(1)} s`;
  return `${(s / 60).toFixed(1)} m`;
}

export function emailDomain(addr) {
  if (!addr) return "";
  const m = addr.match(/@([^>\s]+)/);
  return m ? m[1].toLowerCase() : "";
}

export function extractName(addr) {
  if (!addr) return "";
  const m = addr.match(/^\s*"?([^"<]+?)"?\s*<.+>\s*$/);
  return m ? m[1].trim() : addr;
}
